import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from "react-router-dom";
import Header from '../../Header';
import Footer from '../../Footer';
import config from "../../common/Config";
import { toast } from 'sonner';
import { Box, Typography, TextField, Button, Grid2, Select, MenuItem, FormControl, InputLabel, Paper } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV3';
import { parse, format, isValid } from 'date-fns';
import '../../common/commonStyles.css';
import { postEditSupplier, axiosPostSupplierMultipart } from '../../../utils/supplierApi';

const yesNoApiToForm = (v) => {
  if (v === true || v === 1 || v === '1') return '1';
  if (typeof v === 'string' && v.trim().toLowerCase() === 'yes') return '1';
  if (v === false || v === 0 || v === '0') return '0';
  if (typeof v === 'string' && v.trim().toLowerCase() === 'no') return '0';
  return '';
};

const isYesBinary = (v) =>
  v === true ||
  v === 1 ||
  v === '1' ||
  (typeof v === 'string' && v.trim().toLowerCase() === 'yes');

const Edit_Supplier = () => {
  
  const { supplierId } = useParams();
  const accessToken = localStorage.getItem('accessToken'); 
  const company_tax_type = localStorage.getItem("company_tax_type") || ""; 
  const navigateToSupplierList = useNavigate(); 
  const [errors, setErrors] = useState({});
  const token = localStorage.getItem("token");
  const [formData, setFormData] = useState({
    id : '',
    company: '',
    name: '',
    email: '',
    phone: '',
    address: '',
    vat_no: '',
    contact_person: '',
    contact_person_mob: '',
    contact_person_email: '',
    city: '',
    state: '',
    country: '',
    postal_code: '',
    po_delivery_days: '',
    payment_clearance_days: '',
    tobacco: '',
    tpd_license_no: '',
    tpd_license_validity: '',
    alcohol: '',
    awrs_license_no: '',
    awrs_license_validity: '',
    finance_person: '',
    finance_person_mob: '',
    finance_person_email: '',
    supplier_account_number: '',
    supplier_branch_name: '',
    supplier_bank_name: '',
    supplier_branch_code: '',
  });
  const validateForm = () => {
    const newErrors = {};

    // Company validation
    if (!formData.company) {
      newErrors.company = "Mention company Name.";
    } else if (formData.company.length < 2) {
      newErrors.company = "Company name must consist of at least 2 characters.";
    } else if (formData.company.length > 255) {
      newErrors.company = "Company name must not exceed 255 characters.";
    }

    // Name validation
    if (!formData.name) {
      newErrors.name = "Mention Name.";
    } else if (formData.name.length < 2) {
      newErrors.name = "Name must consist of at least 2 characters.";
    } else if (formData.name.length > 255) {
      newErrors.name = "Name must not exceed 255 characters.";
    }

    // Phone validation
    if (!formData.phone) {
      newErrors.phone = "Phone is Required.";
    } else if (!/^\d{10,12}$/.test(formData.phone)) {
      newErrors.phone = "Phone number must be between 10 and 12 digits.";
    }

    // REMOVE: Email validation
    // if (!formData.email) {
    //   newErrors.email = "Mention Email Id.";
    // } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
    //   newErrors.email = "Please enter a valid email.";
    // }

    // Contact person validation
    if (!formData.contact_person) {
      newErrors.contact_person = "Mention person Name.";
    } else if (formData.contact_person.length < 2) {
      newErrors.contact_person = "Contact person name must consist of at least 2 characters.";
    } else if (formData.contact_person.length > 255) {
      newErrors.contact_person = "Contact person name must not exceed 255 characters.";
    }

    // Contact person mobile validation
    if (!formData.contact_person_mob) {
      newErrors.contact_person_mob = "Contact person mobile is Required.";
    } else if (!/^\d{10,12}$/.test(formData.contact_person_mob)) {
      newErrors.contact_person_mob = "Contact person mobile must be between 10 and 12 digits.";
    }

    // REMOVE: Contact person email validation
    // if (!formData.contact_person_email) {
    //   newErrors.contact_person_email = "Mention Contact Person Email.";
    // } else if (!/\S+@\S+\.\S+/.test(formData.contact_person_email)) {
    //   newErrors.contact_person_email = "Please enter a valid contact person email.";
    // }

    // Finance person validation
    if (!formData.finance_person) {
      newErrors.finance_person = "Mention Finance Person Name.";
    } else if (formData.finance_person.length < 2) {
      newErrors.finance_person = "Finance person name must consist of at least 2 characters.";
    } else if (formData.finance_person.length > 255) {
      newErrors.finance_person = "Finance person name must not exceed 255 characters.";
    }

    if (!formData.finance_person_mob) {
      newErrors.finance_person_mob = "finance mobile is Required.";
    } else if (!/^\d{10,12}$/.test(formData.finance_person_mob)) {
      newErrors.finance_person_mob = "finance person mobile must be between 10 and 12 digits.";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    let processedValue = value;
    if (name === 'tobacco' || name === 'alcohol') {
      processedValue = value === 'yes' ? '1' : '0';
    }
    setFormData({ ...formData, [name]: processedValue });

    let fieldErrors = {};

    switch (name) {
      case 'company':
        if (!value) {
          fieldErrors.company = "Mention company Name.";
        } else if (value.length < 2) {

          fieldErrors.company = "Company name must consist of at least 2 characters.";
        } else if (value.length > 255) {
          fieldErrors.company = "Company name must not exceed 255 characters.";
        }
         
        
        if (!fieldErrors.company) {
           fieldErrors.company = '';
        }
        break;

      case 'name':
        if (!value) {
          fieldErrors.name = "Mention Name.";
        } else if (value.length < 2) {
          fieldErrors.name = "Name must consist of at least 2 characters.";
        } else if (value.length > 255) {
          fieldErrors.name = "Name must not exceed 25 characters.";
        }
        if (!fieldErrors.name) {
          fieldErrors.name = '';
        }
        break;

      case 'phone':
        if (!value) {
          fieldErrors.phone = "Phone is Required.";
        } else if (!/^\d{10,12}$/.test(value)) {
          fieldErrors.phone = "Phone number must be between 10 and 12 digits.";
        }
        if (!fieldErrors.phone) {
          
          fieldErrors.phone = '';
        }
        break;

      case 'email':
        // REMOVE: Email validation
        // if (!value) {
        //   fieldErrors.email = "Mention Email Id.";
        // } else if (!/\S+@\S+\.\S+/.test(value)) {
        //   fieldErrors.email = "Please enter a valid email.";
        // }
        // if (!fieldErrors.email) {
        //   fieldErrors.email = '';
        // }
        break;

      case 'contact_person':
        if (!value) {
          fieldErrors.contact_person = "Mention person Name.";
        } else if (value.length < 2) {
          fieldErrors.contact_person = "Contact person name must consist of at least 2 characters.";
        } else if (value.length > 255) {
          fieldErrors.contact_person = "Contact person name must not exceed 255 characters.";
        }
        if (!fieldErrors.contact_person) {
          fieldErrors.contact_person = '';
        }
        break;

      case 'contact_person_mob':
        if (!value) {
          fieldErrors.contact_person_mob = "Contact person mobile is Required.";
        } else if (!/^\d{10,12}$/.test(value)) {
          fieldErrors.contact_person_mob = "Contact person mobile must be between 10 and 12 digits.";
        }
        if (!fieldErrors.contact_person_mob) {
          fieldErrors.contact_person_mob = '';
        }
        break;

      case 'contact_person_email':
        // REMOVE: Contact person email validation
        // if (!value) {
        //   fieldErrors.contact_person_email = "Mention Contact Person Email.";
        // } else if (!/\S+@\S+\.\S+/.test(value)) {
        //   fieldErrors.contact_person_email = "Please enter a valid contact person email.";
        // }
        // if (!fieldErrors.contact_person_email) {
        //   fieldErrors.contact_person_email = '';
        // }
        break;

      case 'finance_person':
        if (!value) {
          fieldErrors.finance_person = "Mention Finance Person Name.";
        } else if (value.length < 2) {
          fieldErrors.finance_person = "Finance person name must consist of at least 2 characters.";
        } else if (value.length > 255) {
          fieldErrors.finance_person = "Finance person name must not exceed 255 characters.";
        }
        if (!fieldErrors.finance_person) {
          fieldErrors.finance_person = '';
        }
        break;

      case 'finance_person_mob':
        if (!value) {
          fieldErrors.finance_person_mob = "Contact person mobile is Required.";
        } else if (!/^\d{10,12}$/.test(value)) {
          fieldErrors.finance_person_mob = "Contact person mobile must be between 10 and 12 digits.";
        }
        if (!fieldErrors.finance_person_mob) {
          fieldErrors.finance_person_mob = '';
        }
        break;

      default:
        break;
    }

    setErrors((prevErrors) => ({
      ...prevErrors,
      ...fieldErrors
    }));
  };

  const submitUpdateSupplierForm = async () => {

   if (!validateForm()) return; // Validate before submission

    const form = document.getElementById('editsupplierform');

    const multipart = new FormData(form);
    multipart.set('tobacco', isYesBinary(formData.tobacco) ? '1' : '0');
    multipart.set('alcohol', isYesBinary(formData.alcohol) ? '1' : '0');
    try {
      const result = await axiosPostSupplierMultipart(
        `${config.API_URL}/update_supplier`,
        token,
        multipart
      );

      if (result.success == true){
          toast.success("Supplier updated successfully.");
          setTimeout(() => {
            navigateToSupplierList(`/supplier/`);
          }, 1000);

      }else{
        toast.error("Supplier updated Failed. Try Again");
      }

      } catch (error) {
        if (error.message === 'ENCRYPT_KEY_MISSING') {
          toast.error('Encryption key missing.');
        } else {
          toast.error("An error occurred while updating supplier.");
        }
      }
  };


  const fetchEditSupplierData = async () => {
      const apiUrl = `${config.API_URL}/edit_supplier`;
      try {
        const data = await postEditSupplier(apiUrl, token, supplierId);

        if (!data?.success || !data?.data) {
          throw new Error('Failed to fetch supplier data');
        }

        setFormData({
          id : data.data.id,
          company: data.data.company,
          name: data.data.name,
          email: data.data.email,
          phone: data.data.phone,
          address: data.data.address,
          vat_no: data.data.vat_no,
          contact_person: data.data.contact_person,
          contact_person_mob: data.data.contact_person_mob,
          contact_person_email: data.data.contact_person_email,
          city: data.data.city,
          state: data.data.state,
          country: data.data.country,
          postal_code: data.data.postal_code,
          po_delivery_days: data.data.po_delivery_days,
          payment_clearance_days: data.data.payment_clearance_days,
          tobacco: yesNoApiToForm(data.data.tobacco),
          tpd_license_no: data.data.tpd_license_no,
          tpd_license_validity: data.data.tpd_license_validity,
          alcohol: yesNoApiToForm(data.data.alcohol),
          awrs_license_no: data.data.awrs_license_no,
          awrs_license_validity: data.data.awrs_license_validity,
          finance_person: data.data.finance_person,
          finance_person_mob: data.data.finance_person_mob,
          finance_person_email: data.data.finance_person_email,
          supplier_account_number: data.data.supplier_account_number,
          supplier_branch_name: data.data.supplier_branch_name,
          supplier_bank_name: data.data.supplier_bank_name,
          supplier_branch_code: data.data.supplier_branch_code,
        });

      } catch (error) {
      }
  };

  
  useEffect(() => {
    if (accessToken === null) {
      window.location.href = `${config.BASE_URL}/login`;
      return;
    }
    if (supplierId) {
      fetchEditSupplierData();
    }
  }, [supplierId]);

  return (
    <>
      <Box sx={{ width: "100%", p:1.5, backgroundColor: "#f5f7fa"}}>
        <Paper
          elevation={0}
          sx={{
            borderRadius: 2,
            border: '1px solid rgba(145, 158, 171, 0.16)',
          }}
        >
          <Box sx={{ px: 3, py: 2 }}>
          <Box component="form" id="editsupplierform">
            <Typography sx={{ fontSize: '16px', fontWeight: 500, my:1}}>Company Detail</Typography>
            <Grid2 container spacing={3} sx={{ mb: 3 }}>
              <Grid2 size={{ xs: 12, sm: 3 }}>
                <TextField
                  className="form-input-border"
                  fullWidth
                  size="small"
                  label="Company"
                  name="company"
                  id="company"
                  value={formData.company}
                  onChange={handleChange}
                  error={!!errors.company}
                  helperText={errors.company}
                  required
                />
              </Grid2>
              <Grid2 size={{ xs: 12, sm: 3 }}>
                <TextField
                  className="form-input-border"
                  fullWidth
                  size="small"
                  label="Name"
                  name="name"
                  id="name"
                  value={formData.name}
                  onChange={handleChange}
                  error={!!errors.name}
                  helperText={errors.name}
                  required
                />
              </Grid2>
              <Grid2 size={{ xs: 12, sm: 3 }}>
                <TextField
                  className="form-input-border"
                  fullWidth
                  size="small"
                  label="Email Address"
                  name="email"
                  id="email"
                  type="email"
                  value={formData.email}
                  onChange={handleChange}
                />
              </Grid2>
              <Grid2 size={{ xs: 12, sm: 3 }}>
                <TextField
                  className="form-input-border"
                  fullWidth
                  size="small"
                  label="Phone"
                  name="phone"
                  id="phone"
                  type="tel"
                  value={formData.phone}
                  onChange={handleChange}
                  error={!!errors.phone}
                  helperText={errors.phone}
                  required
                  inputProps={{
                    style: {
                      appearance: "none",
                      MozAppearance: "textfield",
                    }
                  }}
                />
              </Grid2>
            </Grid2>
            <Grid2 container spacing={3} sx={{ mb: 3 }}>
              <Grid2 size={{ xs: 12, sm: 4 }}>
                <TextField
                  className="form-input-border"
                  fullWidth
                  size="small"
                  label="Address"
                  name="address"
                  id="address"
                  multiline
                  rows={3}
                  value={formData.address}
                  onChange={handleChange}
                />
              </Grid2>
              <Grid2 size={{ xs: 12, sm: 2 }}>
                <TextField
                  className="form-input-border"
                  fullWidth
                  size="small"
                  label="City"
                  name="city"
                  id="city"
                  value={formData.city}
                  onChange={handleChange}
                />
              </Grid2>
              <Grid2 size={{ xs: 12, sm: 2 }}>
                <TextField
                  className="form-input-border"
                  fullWidth
                  size="small"
                  label="State"
                  name="state"
                  id="state"
                  value={formData.state}
                  onChange={handleChange}
                />
              </Grid2>
              <Grid2 size={{ xs: 12, sm: 2 }}>
                <TextField
                  className="form-input-border"
                  fullWidth
                  size="small"
                  label="Country"
                  name="country"
                  id="country"
                  value={formData.country}
                  onChange={handleChange}
                />
              </Grid2>
              <Grid2 size={{ xs: 12, sm: 2 }}>
                <TextField
                  className="form-input-border"
                  fullWidth
                  size="small"
                  label="Postal Code"
                  name="postal_code"
                  id="postal_code"
                  value={formData.postal_code}
                  onChange={handleChange}
                />
              </Grid2>
            </Grid2>

            <Typography sx={{ fontSize: '16px', fontWeight: 500, my:1}}>Contact Person</Typography>
            <Grid2 container spacing={3} sx={{ mb: 3 }}>
              <Grid2 size={{ xs: 12, sm: 4 }}>
                <TextField
                  className="form-input-border"
                  fullWidth
                  size="small"
                  label="Name"
                  name="contact_person"
                  id="contact_person"
                  value={formData.contact_person}
                  onChange={handleChange}
                  error={!!errors.contact_person}
                  helperText={errors.contact_person}
                  required
                />
              </Grid2>
              <Grid2 size={{ xs: 12, sm: 4 }}>
                <TextField
                  className="form-input-border"
                  fullWidth
                  size="small"
                  label="Phone"
                  name="contact_person_mob"
                  id="contact_person_mob"
                  type="tel"
                  value={formData.contact_person_mob}
                  onChange={handleChange}
                  error={!!errors.contact_person_mob}
                  helperText={errors.contact_person_mob}
                  required
                  inputProps={{
                    style: {
                      appearance: "none",
                      MozAppearance: "textfield",
                    }
                  }}
                />
              </Grid2>
              <Grid2 size={{ xs: 12, sm: 4 }}>
                <TextField
                  className="form-input-border"
                  fullWidth
                  size="small"
                  label="Email"
                  name="contact_person_email"
                  id="contact_person_email"
                  type="email"
                  value={formData.contact_person_email}
                  onChange={handleChange}
                />
              </Grid2>
            </Grid2>

            <Typography sx={{ fontSize: '16px', fontWeight: 500, my:1}}>Licence Details</Typography>
            <Grid2 container spacing={3} sx={{ mb: 3 }}>
       
              <Grid2 size={{ xs: 12, sm: 3 }}>
                <FormControl fullWidth size="small">
                  <InputLabel>Tobacco Product</InputLabel>
                  <Select
                    id="tobacco"
                    value={isYesBinary(formData.tobacco) ? 'yes' : 'no'}
                    label="Tobacco Product"
                    onChange={(e) =>
                      handleChange({ target: { name: 'tobacco', value: e.target.value } })
                    }
                  >
                    <MenuItem value="yes">Yes</MenuItem>
                    <MenuItem value="no">No</MenuItem>
                  </Select>
                </FormControl>
                <input type="hidden" name="tobacco" value={isYesBinary(formData.tobacco) ? '1' : '0'} />
              </Grid2>
              <Grid2 size={{ xs: 12, sm: 3 }}>
                <TextField
                  className="form-input-border"
                  fullWidth
                  size="small"
                  label="TPD License Number"
                  name="tpd_license_no"
                  id="tpd_license_no"
                  value={formData.tpd_license_no}
                  onChange={handleChange}
                />
              </Grid2>
              <Grid2 size={{ xs: 12, sm: 3 }}>
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <DatePicker
                  className="form-input-border"
                    label="TPD License Validity Till Date"
                    value={formData.tpd_license_validity ? (isValid(parse(formData.tpd_license_validity, 'yyyy-MM-dd', new Date())) ? parse(formData.tpd_license_validity, 'yyyy-MM-dd', new Date()) : null) : null}
                    onChange={(newValue) => {
                      const formattedDate = newValue ? format(newValue, 'yyyy-MM-dd') : '';
                      setFormData({ ...formData, tpd_license_validity: formattedDate });
                    }}
                    slotProps={{
                      textField: {
                        size: 'small',
                        fullWidth: true,
                        name: 'tpd_license_validity',
                        id: 'tpd_license_validity',
                      }
                    }}
                  />
                </LocalizationProvider>
              </Grid2>
            </Grid2>
            <input type="hidden" name="sid" value={formData.id} />

            <Grid2 container spacing={3} sx={{ mb: 3 }}>
              <Grid2 size={{ xs: 12, sm: 3 }}>
                <FormControl fullWidth size="small">
                  <InputLabel>Alcohol Licence</InputLabel>
                  <Select
                    id="alcohol"
                    value={isYesBinary(formData.alcohol) ? 'yes' : 'no'}
                    label="Alcohol Licence"
                    onChange={(e) =>
                      handleChange({ target: { name: 'alcohol', value: e.target.value } })
                    }
                  >
                    <MenuItem value="yes">Yes</MenuItem>
                    <MenuItem value="no">No</MenuItem>
                  </Select>
                </FormControl>
                <input type="hidden" name="alcohol" value={isYesBinary(formData.alcohol) ? '1' : '0'} />
              </Grid2>
              <Grid2 size={{ xs: 12, sm: 3 }}>
                <TextField
                  className="form-input-border"
                  fullWidth
                  size="small"
                  label="AWRS License Number"
                  name="awrs_license_no"
                  id="awrs_license_no"
                  value={formData.awrs_license_no}
                  onChange={handleChange}
                />
              </Grid2>
              <Grid2 size={{ xs: 12, sm: 3 }}>
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <DatePicker
                  className="form-input-border"
                    label="AWRS License Validity Till Date"
                    value={formData.awrs_license_validity ? (isValid(parse(formData.awrs_license_validity, 'yyyy-MM-dd', new Date())) ? parse(formData.awrs_license_validity, 'yyyy-MM-dd', new Date()) : null) : null}
                    onChange={(newValue) => {
                      const formattedDate = newValue ? format(newValue, 'yyyy-MM-dd') : '';
                      setFormData({ ...formData, awrs_license_validity: formattedDate });
                    }}
                    slotProps={{
                      textField: {
                        size: 'small',
                        fullWidth: true,
                        name: 'awrs_license_validity',
                        id: 'awrs_license_validity',
                      }
                    }}
                  />
                </LocalizationProvider>
              </Grid2>
            </Grid2>

            <Typography sx={{ fontSize: '16px', fontWeight: 500, my:1}}>Banking & Finance Details</Typography>
            <Grid2 container spacing={3} sx={{ mb: 3 }}>
              <Grid2 size={{ xs: 12, sm: 3 }}>
                <TextField
                  className="form-input-border"
                  fullWidth
                  size="small"
                  label="Financial Person Name"
                  name="finance_person"
                  id="finance_person"
                  value={formData.finance_person}
                  onChange={handleChange}
                  error={!!errors.finance_person}
                  helperText={errors.finance_person}
                  required
                />
              </Grid2>
              <Grid2 size={{ xs: 12, sm: 3 }}>
                <TextField
                  className="form-input-border"
                  fullWidth
                  size="small"
                  label="Financial Person Mobile"
                  name="finance_person_mob"
                  id="finance_person_mob"
                  type="tel"
                  value={formData.finance_person_mob}
                  onChange={handleChange}
                  error={!!errors.finance_person_mob}
                  helperText={errors.finance_person_mob}
                  required
                  inputProps={{
                    style: {
                      appearance: "none",
                      MozAppearance: "textfield",
                    }
                  }}
                />
              </Grid2>
              <Grid2 size={{ xs: 12, sm: 3 }}>
                <TextField
                  className="form-input-border"
                  fullWidth
                  size="small"
                  label="Financial Person Email"
                  name="finance_person_email"
                  id="finance_person_email"
                  type="email"
                  value={formData.finance_person_email}
                  onChange={handleChange}
                />
              </Grid2>
              <Grid2 size={{ xs: 12, sm: 3 }}>
                <TextField
                  className="form-input-border"
                  fullWidth
                  size="small"
                  label={`${company_tax_type} Number`}
                  name="vat_no"
                  id="vat_no"
                  type="number"
                  value={formData.vat_no}
                  onChange={handleChange}
                />
              </Grid2>
            </Grid2>

            <Typography sx={{ fontSize: '16px', fontWeight: 500, my:0.5}}>Banking Details</Typography>
            <Grid2 container spacing={3} sx={{ mb: 3 }}>
              <Grid2 size={{ xs: 12, sm: 3 }}>
                <TextField
                  className="form-input-border"
                  fullWidth
                  size="small"
                  label="Bank Account Number"
                  name="supplier_account_number"
                  id="supplier_account_number"
                  value={formData.supplier_account_number}
                  onChange={handleChange}
                />
              </Grid2>
              <Grid2 size={{ xs: 12, sm: 3 }}>
                <TextField
                  className="form-input-border"
                  fullWidth
                  size="small"
                  label="Branch Name"
                  name="supplier_branch_name"
                  id="supplier_branch_name"
                  value={formData.supplier_branch_name}
                  onChange={handleChange}
                />
              </Grid2>
              <Grid2 size={{ xs: 12, sm: 3 }}>
                <TextField
                  className="form-input-border"
                  fullWidth
                  size="small"
                  label="Bank Name"
                  name="supplier_bank_name"
                  id="supplier_bank_name"
                  value={formData.supplier_bank_name}
                  onChange={handleChange}
                />
              </Grid2>
              <Grid2 size={{ xs: 12, sm: 3 }}>
                <TextField
                  className="form-input-border"
                  fullWidth
                  size="small"
                  label="Branch Code"
                  name="supplier_branch_code"
                  id="supplier_branch_code"
                  value={formData.supplier_branch_code}
                  onChange={handleChange}
                />
              </Grid2>
            </Grid2>

            <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 4, pt: 3, borderTop: '1px solid rgba(145, 158, 171, 0.16)' }}>
              <Button
                variant="contained"
                className="button-variant-contained"
                onClick={submitUpdateSupplierForm}
              >
                Update Supplier
              </Button>
            </Box>
          </Box>
          </Box>
        </Paper>
      </Box>
   
    </>
  );
};

export default Edit_Supplier;